<template>
    <div id="manageClass">
        <div>
            <div class="Secondary">

            </div>
        </div>
        <div class="allBodyDiv">
            <nb-tags></nb-tags>
            <div style="margin-top: 15px">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/manageclass' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>考试列表</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <el-row class="manageClassBody" :gutter="20">
                <el-col :span="24" class="leftMember">
                    <el-card class="box-card listCard2">
                        <div slot="header" class="clearfix" style="height: 34px;line-height: 34px">
                            <i class="blueI" style="left: 10px"></i>
                            <span class="cardHeader">实验发布列表（{{numList}}）</span>
                            <div class="fr">
                                <el-button id="release fr" @click="releaseBtn" type="primary">发布考试</el-button>
                            </div>
                        </div>
                        <div v-for="i in tableData3">
                            <div v-if="i.finish==0" class="testReleaseList">
                                <div class="listHeader">
                                    <span class="listHeader-title">{{i.group_name}}</span>
                                    <span class="listHeader-time">发布时间：{{i.start_time}}</span>
                                    <el-button @click="relectUpdo(i.group_id)"
                                               class="listHeader-btn" type="primary" size="mini">撤销</el-button>
                                    <span class="fr listHeader-overTime">距离结束：{{i.endTime}}</span>
                                </div>
                                <div class="listBody">
                                    <el-table
                                            :show-header="false"
                                            :data="i.item"
                                            border
                                            highlight-current-row
                                            row-class-name="graspTr"
                                            header-row-class-name="graspHeader"
                                            style="width: 100%">
                                        <el-table-column
                                                width="355"
                                                label="实验名">
                                            <template slot-scope="props">
                                                    <span @click="$router.push({ path: '/testdetails', query: { plan: props.row.examination_id,title:i.group_name,name:props.row.name}})">
                                                        {{props.row.name}}
                                                    </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="avg_score"
                                                width="170"
                                                label="">
                                        </el-table-column>
                                        <el-table-column
                                                label="操作">
                                            <template slot-scope="props">
                                                <div style="display:inline-block;width:200px">
                                                    <el-progress :percentage="props.row.ratioHalf" status="success" :show-text="false"></el-progress>
                                                </div>
                                                <span>{{props.row.sub_num}}人</span>/
                                                <span>共{{props.row.studentNum}}人</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>

                            <div v-else class="Unpublished">
                                <div class="listHeader">
                                    <span class="listHeader-title">{{i.group_name}}</span>
                                    <span class="listHeader-time">发布时间：{{i.start_time}}</span>
                                    <span class="listHeader-overTime">已结束</span>
                                </div>
                                <div class="listBody">
                                    <el-table
                                            :show-header="false"
                                            :data="i.item"
                                            border
                                            highlight-current-row
                                            row-class-name="graspTr"
                                            header-row-class-name="graspHeader"
                                            style="width: 100%">
                                        <el-table-column
                                                width="355"
                                                label="实验名">
                                            <template slot-scope="props">
                                                    <span @click="$router.push({ path: '/testdetails', query: { plan: props.row.examination_id,title:i.group_name,name:props.row.name}})">
                                                        {{props.row.name}}
                                                    </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="avg_score"
                                                width="170"
                                                label="">
                                        </el-table-column>
                                        <el-table-column
                                                label="操作">
                                            <template slot-scope="props">
                                                <div style="display:inline-block;width:200px">
                                                    <el-progress :percentage="props.row.ratioHalf" status="success" :show-text="false"></el-progress>
                                                </div>
                                                <span>{{props.row.sub_num}}人</span>/
                                                <span>共{{props.row.studentNum}}人</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>

                        <div v-if="filters.total>0" style="margin-top:30px;text-align:right;">
                            <el-pagination
                                    @size-change="pageSizeChange"
                                    @current-change="pageChange"
                                    :current-page="currentPage4"
                                    :page-sizes="[5, 10, 20, 30]"
                                    :page-size="filters.pageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="filters.total">
                            </el-pagination>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <!--发布实验-->
        <el-dialog title="" :show-close="false" :visible.sync="releaseTest" custom-class="testDialog" width="1092px">
            <div>
                <el-card class="box-card" style="position: relative;border: none">
                    <div slot="header" class="clearfix">
                        <i class="blueI"></i>
                        <span class="cardHeader">选择实验</span>
                        <span class="fr" style="color:#ff912f;font-size:14px;">已选择{{textNum}}个实验</span>
                    </div>
                    <div class="cardCheck">
                        <div id="testCheck">
                            <el-checkbox-group v-model="releaseForm.checkedTest" @change="textNum=releaseForm.checkedTest.length">
                                <el-checkbox
                                        v-for="i in testList"
                                        :key="i.experiment_id"
                                        :label="i.experiment_id">
                                    <div class="checkDiv">
                                        <img :src="i.icon_url" alt="">
                                        <div class="checkName">{{i.name}}</div>
                                    </div>

                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <div class="releaseBody" style="margin-top:20px;">
                        <el-form :model="releaseForm" :rules="rulesRelease" ref="releaseForm" class="demo-ruleForm">
                            <el-form-item label="考试名称" prop="name" label-width="80px" style="width:380px;">
                                <el-input style="width:280px;" v-model="releaseForm.name" placeholder="实验名称最多十五个字"></el-input>
                            </el-form-item>
                            <el-form-item label="考试时间" prop="time" label-width="264px" style="width:480px;">
                                <el-date-picker
                                        v-model="releaseForm.time"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="选择班级" prop="checkClass" label-width="80px" style="width: 100%">
                                <el-checkbox-group v-model="releaseForm.checkClass">
                                    <el-checkbox
                                            v-for="i in classList"
                                            :key="i.class_id"
                                            v-if="$route.query.plan==i.class_id"
                                            disabled
                                            :label="i.class_id">
                                        {{i.classname}}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
            </div>
            <span slot="footer" class="dialog-footer" style="text-align: center">
                <div>
                    <el-button @click="releaseTest = false">取 消</el-button>
                    <el-button type="primary" @click="nextRelease('releaseForm')">下一步</el-button>
                </div>
            </span>
        </el-dialog>

        <!--发布实验2-->
        <el-dialog title="" :show-close="false" :visible.sync="releaseTest2" custom-class="testDialog" width="680px">
            <div>
                <el-card class="box-card" style="position: relative;border: none">
                    <div slot="header" class="clearfix">
                        <i class="blueI"></i>
                        <span class="cardHeader">确认信息</span>
                    </div>
                    <div>
                        <el-form  ref="sureReleaseForm" class="demo-ruleForm" label-width="90px">
                            <el-form-item label="考试名称" prop="name">
                                <span>{{releaseForm.name}}</span>
                            </el-form-item>
                            <el-form-item label="考试时间" prop="time">
                                <span>{{timeArrray[0]}}</span>&nbsp;&nbsp;至&nbsp;&nbsp;<span>{{timeArrray[1]}}</span>
                            </el-form-item>
                            <el-form-item label="考试班级" prop="checkClass">
                                <span>{{classSelected}}</span>
                            </el-form-item>
                            <el-form-item label="已选实验" prop="checkClass">
                                <div>
                                    <span>共选{{textNum}}实验</span>
                                    <el-table
                                            :data="releaseArray"
                                            :show-header="false"
                                            style="width: 100%">
                                        <el-table-column
                                                prop="name">
                                        </el-table-column>
                                        <el-table-column>
                                            <template slot-scope="props">
                                                <span>设置时长</span>
                                                <el-input :maxlength="3" style="width:40px;height:40px;" class="testTime" v-model="props.row.exam_timelength"></el-input>
                                                <span>分钟</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
            </div>
            <span slot="footer" class="dialog-footer" style="text-align: center">
                <div>
                    <el-button @click="releaseTest = true;releaseTest2=false">上一步</el-button>
                    <el-button type="primary" :loading="releaseLoading" @click="releaseTestConfirm()">发 布</el-button>
                </div>
            </span>
        </el-dialog>

        <el-dialog title="撤销发布" :visible.sync="releaseUndo" custom-class="nbDialog" width="500px">
            <div style="width: 375px;margin: auto">
                <div style="font-size:18px;margin-bottom: 15px">您确认要撤销发布实验吗？ </div>
                <span style="font-size:14px;color:#b5b5b5"> 实验撤销后，已完成的实验数据也将全部清除且无法找回！</span>
            </div>
            <span slot="footer" class="dialog-footer" style="text-align: center">
                <div>
                    <el-button @click="releaseUndo = false">取 消</el-button>
                    <el-button type="primary" @click="undoGroup">确 定</el-button>
                </div>
            </span>
        </el-dialog>

    </div>
</template>
<script>
    import{
        getpushlist,
        getexamlist,
        getclasslist,
        pushexam,
        revokepublic
    }from'./../../api/exam_api'
    export default {
        data() {
            return{
                numList:0,
                releaseUndo:false,
                tableData3:[],
                filters: {
                    pageSize: 5,
                    total: 0,
                    page: 1,
                },
                currentPage4:1,
                releaseTest:false,
                releaseTest2:false,
                textNum:0,
                releaseForm:{
                    checkedTest:[],
                    name:'',
                    time:'',
                    checkClass:[]
                },
                testList:[],
                rulesRelease:{
                    name: [
                        { required: true,min:2,max:15, message: '请输入2到15位考试名称', trigger: 'blur' },
                    ],
                    time: [
                        { required: true, message: '请选择起止时间', trigger: 'blur' },
                    ],
                    checkClass: [
                        { required: true, message: '请选择班级', trigger: 'blur' },
                    ],
                },
                classData:[],
                timeArrray:[],
                classSelected:'',
                releaseArray:[],
                releaseLoading:false,
                classList:[]
            }
        },
        methods:{
            //撤销
            relectUpdo(groupId){
                this.releaseUndo=true;
                this.groupId=groupId;
            },
            undoGroup(){
                revokepublic({group_id:this.groupId,class_id:this.$route.query.plan}).then((res)=>{
                    if(res.code==200){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        this.releaseUndo=false;
                        this.getPushTestList()
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                    }
                });
            },
            pageSizeChange(val){
                this.filters.pageSize = val;
                this.getList()
            },
            pageChange(val){
                this.filters.page = val;
                this.getList()
            },
            getList(){
                let data={
                    class_id:this.$route.query.plan,
                    page:this.filters.page,
                    perPage:this.filters.pageSize,
                    productid:productID,
                    province_id:areaID,
                };
                getpushlist(data).then((res)=>{
                    this.numList=res.data.total
                    this.tableData3=res.data.data;
                    this.filters.total=res.data.total;
                    this.tableData3.forEach(function(index,i){
                        index.start_time=timestampToTime(index.start_time * 1000);
                        if(index.finish==0){
                            let oDate2=index.stop_time * 1000;
                            let oDate1=new Date();
                            let nTime = oDate2 - oDate1.getTime();
                            let day = Math.floor(nTime/86400000);
                            let hour = Math.floor(nTime%86400000/3600000);
                            let minute = Math.floor(nTime%86400000%3600000/60000);
                            let _time=day+'天 '+hour+'小时 '+minute+'分';
                            index.endTime=_time;
                        }
                        index.item.forEach(function (index, i) {
                            index.avg_score='平均分'+index.avg_score;
                            index.ratioHalf =
                                index.sub_num<=0 ? 0 : (Math.round( index.sub_num / index.studentNum * 10000)/ 100.00);
                        })
                    });
                });
                getclasslist().then((res)=>{
                    if(res.code==200){
                        for(let i=0;i<res.data.length;i++){
                            res.data[i].class_id=res.data[i].class_id.toString();
                        }
                        this.classList=res.data;
                    }
                });
            },
            //发布实验
            releaseBtn(){
                this.releaseForm.checkClass=[];
                this.releaseTest=true;
                this.examList();
                this.releaseForm.checkClass.push(this.$route.query.plan)
            },
            //发布实验下一步
            nextRelease(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.releaseForm.checkedTest.length<=0){
                            this.$message({
                                message: '请至少选择一个实验',
                                type: 'error'
                            });
                        }else{
                            this.releaseArray=[];
                            this.classSelected='';

                            for(let i=0;i<this.classList.length;i++){
                                for(let a=0;a<this.releaseForm.checkClass.length;a++){
                                    if(this.classList[i].class_id==this.$route.query.plan){
                                        this.classSelected+=this.classList[i].classname+'  '
                                    }
                                }
                            }
                            for(let i=0;i<this.testList.length;i++){
                                for(let a=0;a<this.releaseForm.checkedTest.length;a++){
                                    if(this.testList[i].experiment_id==this.releaseForm.checkedTest[a]){
                                        let obj={
                                            name:this.testList[i].name,
                                            experiment_id:this.testList[i].experiment_id,
                                            exam_timelength:10
                                        };
                                        this.releaseArray.push(obj);
                                    }
                                }
                            }

                            this.timeArrray=this.releaseForm.time.slice(0,this.releaseForm.time.length)
                            for(let i=0;i<this.timeArrray.length;i++){
                                this.timeArrray[i]=timestampToTime(this.timeArrray[i].getTime());
                            }
                            this.releaseTest=false;
                            this.releaseTest2=true;

                        }
                    }
                })
            },
            //确定发布实验
            releaseTestConfirm(){
                this.releaseArray.forEach(function (index, i) {
                    if(index.exam_timelength<=0){
                        this.$message({
                            message: '请设置'+index.name+'的时长',
                            type: 'error'
                        });
                        return false;
                    }else{
                        index.exam_timelength=parseInt(index.exam_timelength);
                    }
                }.bind(this));
                this.releaseLoading=true;
                let data={
                    experiment:this.releaseArray,
                    group_name:this.releaseForm.name,
                    start_time:this.releaseForm.time[0].getTime()/1000,
                    stop_time:this.releaseForm.time[1].getTime()/1000,
                    class_id:this.releaseForm.checkClass,
                    productid:productID,
                    province_id:areaID
                };
                pushexam(data).then((res)=>{
                    if(res.code==200){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        this.releaseLoading=false;
                        this.releaseTest2=false;
                        this.releaseForm={
                            checkedTest:[],
                            name:'',
                            time:'',
                            checkClass:[]
                        };
                        this.getList();
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                        this.releaseLoading=false;
                    }
                });
            },
            //实验列表
            examList(){
                getexamlist({productid:productID,province_id:areaID}).then((res)=>{
                    if(res.code==200){
                        this.testList=res.data.data;
                    }
                });
            },
        },
        mounted(){
            this.getList();
        }
    }
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/assets/js/pages/exam/TestList.vue